import React, { useEffect } from "react";

import Novedades from "../components/Novedades/Novedades";
import i18n from "../i18n/config";

const NovedadesPage = () => {
  useEffect(() => {
    document.title = `${window._env_.REACT_APP_EMPRESA_NAME} - ${i18n.t("list.breadcrumb", { ns: "novedades" })}`;
  }, []);

  return <Novedades />;
};

export default NovedadesPage;
